
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import AdminPanel from '@/components/AdminPanel';
import ErrorBoundary from '@/components/ErrorBoundary';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { SidebarProvider, useSidebarContext } from '@/contexts/SidebarContext';
import AppSidebar from '@/components/AppSidebar';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';


const AdminContent: React.FC<{
  returnToDashboard: boolean;
  handleBackToDashboard: () => void;
}> = ({ returnToDashboard, handleBackToDashboard }) => {
  const { compact } = useSidebarContext();
  const isMobile = useIsMobile();

  return (
    <div className="flex min-h-screen w-full">
      <AppSidebar activePage="settings" />
      <div className={cn(
        "flex-1 min-w-0 px-6 pb-12 overflow-x-hidden transition-all duration-300",
        !isMobile && (compact ? "ml-16" : "ml-64")
      )}>
        <div className="max-w-6xl mx-auto">
          {returnToDashboard && (
            <Button 
              variant="outline" 
              className="mb-6" 
              onClick={handleBackToDashboard}
            >
              <ArrowLeft className="w-4 h-4 mr-2" /> 
              Back to Dashboard
            </Button>
          )}
          <ErrorBoundary>
            <AdminPanel />
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

const Admin: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const returnToDashboard = location.state?.returnToDashboard;

  useEffect(() => {
    console.log("Admin: Initialized with location state:", location.state);
  }, [location.state]);

  const handleBackToDashboard = () => {
    console.log("Admin: Navigating back to dashboard with preserveResults flag");
    // Navigate back to dashboard while preserving crawl results
    navigate('/dashboard', { 
      state: { 
        preserveResults: true,
        fromAdmin: true  // Add this flag to identify source
      } 
    });
  };

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <SidebarProvider>
          <AdminContent 
            returnToDashboard={returnToDashboard}
            handleBackToDashboard={handleBackToDashboard}
          />
        </SidebarProvider>
      </main>
    </div>
  );
};

export default Admin;
